import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { dataUserSession } from "../../../utilities/dataSession";
import { Loading } from "../../../components/Loading/Loading";
import { normalColumn, actionColumnCustomLableInfo, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

//SERVICE
import { pContractorContractList } from "../../../service/100/P109Service";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P109() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [requestSrh, setRequestSrh] = useState({ userId: "" });

    //Data
    const [dataTable, setDataTable] = useState([]);

    //SerchTable
    const [userRole, setUserRole] = useState("1");
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    useEffect(() => {
        if (dataUserSession()) {
            setRequestSrh({
                userId: dataUserSession().userId,
            });
            setUserRole(dataUserSession().userRole)
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGetContractorContractList();
    }, [requestSrh]);

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onGetContractorContractList = () => {
        setLoading(true);
        pContractorContractList(requestSrh).then(
            (res) => {
            // console.log(" res", res)
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const headerLabel = <span className="hidden-responsive">กลับหน้าจอหลัก</span>;
    const header = (
        <div className="table-header">
            <Button className="p-button p-button-secondary btn-hidden-responsive " icon="pi pi-arrow-left" label={headerLabel} onClick={()=>checkDash()} />
        </div>
    );

    const checkDash = () =>{

        if(userRole === "3" || userRole === 'A'){
            history.push("/301")
        }else{
            history.push("/")
        }

    }

    const actionBodyDetail = (rowData) => {
        history.push({
            pathname: "/115",
            state: {
                contractNo: rowData.contractNo,
                routeNo : rowData.routeNo
            },
        });
    };
    const actionBodyEdit = (rowData) => {
        history.push({
            pathname: "/110",
            state: { dataSrh: { contractNo: rowData.contractNo, routeNo: rowData.routeNo, routeName: rowData.routeName } },
        });
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="datatable-responsive-modify">
                            <div className="card">
                                {/* <h2 className="p-m-0">รายละเอียดสัญญา/เส้นทาง</h2>
                                <hr /> */}
                                <DataTable
                                    // ref={(el) => dt = el}
                                    value={dataTable}
                                    dataKey="id"
                                    paginator
                                    first={pageConf.first}
                                    rows={pageConf.rows}
                                    onPage={(e) => onPageChange(e, setPageConf)}
                                    rowsPerPageOptions={rowsPerPageOptions()}
                                    paginatorTemplate={paginatorTemplate()}
                                    currentPageReportTemplate={currentPageReportTemplate()}
                                    header={header}
                                    emptyMessage="ไม่พบข้อมูล"
                                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                                    selectionMode="single"
                                >
                                    <Column field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNo", "เลขที่สัญญา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                                    <Column sortable field="routeName" header="เส้นทาง" body={(e) => normalColumn(e, "routeName", "เส้นทาง")} style={{ textAlign: "center", width: "30%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                                    <Column sortable field="contractType" header="ประเภทสัญญา" body={(e) => normalColumn(e, "contractType", "ประเภทสัญญา")} style={{ textAlign: "center", width: "12%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                                    <Column sortable field="contractPeriod" header="ช่วงวันที่" body={(e) => normalColumn(e, "contractPeriod", "ช่วงวันที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                                    <Column sortable field="remainDay" header="จำนวนวันที่เหลือ" body={(e) => normalColumn(e, "remainDay", "จำนวนวันที่เหลือ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                                    <Column sortable field="contractAmount" header="มูลค่า" body={(e) => normalColumn(e, "contractAmount", "มูลค่า")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                                    <Column sortable field="withdrawAmount" header="เบิกเงินเเล้ว" body={(e) => normalColumn(e, "withdrawAmount", "เบิกเงินเเล้ว")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                                    <Column field="withdrawPercent" header="%" body={(e) => normalColumn(e, "withdrawPercent", "%")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                                    <Column field="supervisorName" header="ผู้คุมงาน" body={(e) => normalColumn(e, "supervisorName", "ผู้คุมงาน")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                                    <Column field="contractStatus" header="สถานะสัญญา" body={(e) => normalColumn(e, "contractStatus", "สถานะสัญญา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                                    <Column header="ดูรายละเอียด" body={(e) => actionColumnCustomLableInfo(e, actionBodyDetail, "กดเพื่อ ดูรายละเอียด", "fa fa-search")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                                    <Column header="ประมาณการ" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
